import { Account } from 'src/components/embedded-account';
import { PageComponent } from 'src/types';
import { getPrivateDispensaryServerSideProps } from 'src/utils/ssr/get-dispensary-server-side-props';
import { CoreMenuLayout } from 'components/layouts/core-menu-layout';
import { withLayout } from 'src/components/layouts/with-layout';

export const getServerSideProps = getPrivateDispensaryServerSideProps;

const AccountPage: PageComponent = Account;

export default withLayout(AccountPage, CoreMenuLayout);
